'use strict';

var d3 = require('d3');
var ChartClassUsage = function ChartClassUsage(chartFaresService, AbstractChart, scalesService, chartBrush, chartGroups, chartStripes, chartXAxis, chartYAxis, chartConstants, chartCurves, chartCircles) {
  var chartParams = require('./Params');
  var trafficScales = require('./TrafficScales');
  var avgFareScales = require('./AvgFareScales');
  var Chart = function Chart(container, formatters, legend, chartModel) {
    var self = this;
    AbstractChart.call(this, container);
    var dispatch = d3.dispatch('rangechange');
    d3.rebind(this, dispatch, 'on');

    // chart components
    var brush = chartBrush();
    var groups = chartGroups('clazz', formatters.tooltipFormatter, true);
    var stripes = chartStripes('stripesData');
    var avgFareCurve = chartCurves('clazz', 'avgFare', null, undefined).discontinuous(true);
    var prevAvgFareCurve = chartCurves('clazz', 'prevAvgFare', null, undefined).discontinuous(true);
    var circles = chartCircles('avgFareCircle', 3);
    var xAxis = chartXAxis(formatters.xAxisTickFormatter);
    var yAxisRight = chartYAxis(formatters.yAxisTickFormatter, chartConstants.AXIS.MODE.RIGHT).withoutHorizontalLines().withLabelRotation(-90);
    var yAxisLeft = chartYAxis(formatters.yAxisTickFormatter, chartConstants.AXIS.MODE.LEFT).withoutHorizontalLines();
    function updateBrush() {
      if (brush.isSelectionInitialized()) {
        brush.updateBrush();
        dispatch.rangechange(brush.getSelection());
      } else {
        brush.setSelection(chartModel.ranges[0]);
        dispatch.rangechange(brush.getSelection());
      }
    }
    this.render = function (chartModel, sizingParams) {
      var dataAdaptedToChart = chartFaresService.adaptDataToChart(chartModel.data);
      var params = chartParams(chartModel, sizingParams);
      if (chartModel.isFirst) {
        yAxisLeft.label('Average Fare');
      }
      if (chartModel.isLast) {
        yAxisRight.label('Traffic');
      }
      this.initChart(dataAdaptedToChart, [0, chartModel.data.length], params);
      this.trafficScales = trafficScales(this.params, this.data, this.visibleXRange);
      this.avgFareScales = avgFareScales(this.params, this.data, this.visibleXRange, this.trafficScales);
      this.callForPreDataGroup([brush.withDomainRange(this.visibleXRange)], this.trafficScales);
      this.callForDataGroup([yAxisRight, groups, stripes, xAxis], this.trafficScales);
      this.callForDataGroup([yAxisLeft, avgFareCurve, prevAvgFareCurve, circles], this.avgFareScales);
      updateBrush();
    };
    this.resetBrushSelection = function (chartModel) {
      brush.setSelection([0, chartModel.data.length]);
      dispatch.rangechange(brush.getSelection());
    };
    this.clearBrushSelection = function () {
      brush.setSelection([0, 0]);
      dispatch.rangechange(brush.getSelection());
    };
    brush.on('brushchange', function (range) {
      self.brushChangeAction(range, groups);
    });
    brush.on('brushend', function (range) {
      dispatch.rangechange(range);
    });
    groups.on('groupclick', function (d, i, targeData, event) {
      event.preventDefault();
      event.stopPropagation();
      brush.setSelection([i, i + 1]);
      dispatch.rangechange(brush.getSelection(), !event.ctrlKey);
    });
    container.on('$destroy', function () {
      groups.on('groupclick', null);
      brush.on('brushchange', null);
      brush.on('brushend', null);
    });
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
ChartClassUsage.$inject = ['ChartFaresService', 'AbstractChart', 'ScalesService', 'ChartElementsMultiBrush', 'ChartElementsGroup', 'ChartElementsStripes', 'ChartElementsXAxis', 'ChartElementsYAxis', 'ChartElementsConstants', 'ChartElementsCurves', 'ChartElementsCircles'];
module.exports = ChartClassUsage;